import React, { useEffect, useState } from "react"
import { ICountry } from "../../../../types/dict/ICountry"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IErrorModel } from "../../../../types/error/IErrorModel"

export const CountryPicker: React.FC<{
  label?: string
  size: number
  name: string
  value: ICountry[]
  errorModel: IErrorModel | undefined
  placeholder?: string
  _callback: (countryList: ICountry[]) => void
}> = ({ label, size, name, value, errorModel, placeholder, _callback }) => {
  const [countries, setCountries] = useState<ICountry[]>(value)
  const [countryList, setCountryList] = useState<ICountry[]>([])
  const [country, setCountry] = useState<ICountry>()

  useEffect(() => {
    setCountries(value)
  }, [value])

  const handleChangeCountry = (name: string) => {
    setCountry({
      name: name
    })
    TrinityAPI.suggestCountry(name, response => {
      if (response.status === 200) setCountryList(response.data)
    })
  }

  const pickCountry = (country: ICountry) => {
    if (countries.filter(c => c.hex === country.hex).length > 0) return
    const newCountries = [...countries, country]
    setCountries(newCountries)
    setCountry({ name: "" })
    setCountryList([])
    _callback(newCountries)
  }

  const removeCountry = (hex: string | undefined) => {
    if (!hex) return
    const newCountries = countries.filter(c => c.hex !== hex)
    setCountries(newCountries)
    _callback(newCountries)
  }

  const getFieldError = (fieldName: string) => {
    if (errorModel && errorModel.fieldErrors.filter(fe => fe.field === fieldName).length > 0) {
      return errorModel.fieldErrors.filter(fe => fe.field === fieldName)[0].defaultMessage
    }
  }

  return (
    <fieldset className="select-fieldset">
      {label && <legend>{label}</legend>}
      {countries.length === size ? (
        <></>
      ) : (
        <input
          type="text"
          className="input-form"
          placeholder={placeholder || "К примеру France"}
          onChange={e => handleChangeCountry(e.target.value)}
          value={country?.name}
        />
      )}
      <ul className="prompt-list">
        {countryList.map((c, index) => (
          <li className="promp-item" key={index} onClick={() => pickCountry(c)}>
            {c.name?.toUpperCase()}
          </li>
        ))}
      </ul>

      <ul className="tag-list">
        {countries.map((country, index) => (
          <li className="tag-item" key={index}>
            {country?.name?.toUpperCase()}
            <span className="close-country" onClick={() => removeCountry(country.hex)} />
          </li>
        ))}
      </ul>
      {getFieldError(name) ? <p className="error-form">{getFieldError(name)}</p> : <></>}
    </fieldset>
  )
}
